import axios from "axios";
import config from "./config"
import { Message } from "element-ui"


/**
 * 拼接 全局默认 base url
 */
export let baseURL;
baseURL = process.env.VUE_APP_BASE_URL
// 设置全局的请求配置
// switch (process.env.NODE_ENV) {
//   case 'production':
//     baseURL = config.production
//     break
//   case 'outer':
//     baseURL = config.outer
//     break
//   default:
//     baseURL = config.development
// }
// process.env.NODE_ENV === 'production' ? (baseURL = config.production) : (baseURL = config.development);
baseURL += (config.baseURL ? config.baseURL : '');

// 全屏loading对象,配合过渡，可在接口响应快时不显示
// let screen_loading = {
//   loading: null,
//   timer: null,
//   count: 0,
//   options: {
//     background: "rgba(0,0,0,0.7)",
//     customClass: "my-loading"
//   },
//   open () {
//     this.count++;
//     this.loading = ElLoading.service(this.options);
//   },
//   close () {
//     this.count--;
//     if (this.count <= 0) this.loading.close();
//   }
// }

/**
 * 
 * -----------------请求对象基类 ----------
 * 
 * 
 * 创建默认请求对象,暂时支持 get 和 post 请求，其他的没有进行重写
 * 可以通过 this.axios 进行调用
 */
class makeRequest {
  constructor(obj) {
    this.axios = axios.create(obj)
    // 添加请求拦截器
    setInterceptors(this.axios);
  }

  /**
   * get 请求
   * @param url
   * @param params
   * @returns {*} : 返回promise
   */
  get (url, params) {
    return this.axios.get(url, { params })
  }

  /**
   * delete 请求
   * @param url
   * @param params
   * @returns {*} : 返回promise
   */
  delete (url, params) {
    return this.axios.delete(url, { params })
  }

  /**
   *  post 请求
   * @param url
   * @param data
   * @returns {*} 返回promise
   */
  post (url, data) {
    return this.axios.post(url, data)
  }

  /**
   *  put 请求
   * @param url
   * @param data
   * @returns {*} 返回promise
   */
  put (url, data) {
    return this.axios.put(url, data)
  }
}
// 添加拦截器
function setInterceptors (axios) {
  // 添加请求拦截器
  axios.interceptors.request.use(function (config) {
    // screen_loading.open()
    // 在发送请求之前做些什么
    // config.headers['token'] = 'Bearer ';
    return config;
  }, function (error) {
    // screen_loading.close();
    // 对请求错误做些什么
    Message.error('网络发生错误');
    return Promise.reject(error);
  });

  // 添加响应拦截器
  axios.interceptors.response.use(function (response) {
    // screen_loading.close();
    // 对响应数据做点什么
    if (response.status == 200) {
      // switch (response.data.status) {
      //     // 成功类的请求
      //     case 200:
      //         console.log('请求成功：', response.data);
      //     case 1:
      //         console.log('请求成功：', response.data);
      //         return response.data;
      //     case -1:
      //         console.log("权限失败：", response.data);
      //         return Promise.reject(response.data);
      //     default:
      //         console.log("其他原因失败：", response.data);
      //         ElMessage.error(response.data.msg || '网络发生错误');
      //         return Promise.reject(response.data);
      // }
      return response.data;
    } else {
      Message.error(response.data.msg || '网络发生错误');
      return Promise.reject(response.data);
    }
  }, function (error) {
    // screen_loading.close();
    // 对响应错误做点什么
    Message.error('网络发生错误');
    return Promise.reject(error);
  });
}




// ------------------------------------------- 模块导出内容------------------
/**
 * 创建请求对象函数
 * @param obj ： 需要重写的axios配置
 */
export default function (obj) {
  let self_obj = Object.assign({
    baseURL,
    headers: config.headers,
    timeout: config.timeout,
    ...config.other
  }, obj || {})
  // console.log("创建请求对象配置：", baseURL, self_obj);
  return new makeRequest(self_obj);
}


/**
 * 特殊情况下，创建一个自定义配置的请求对象
 * @param obj
 * @returns {obj}
 */
export function createRequest (obj) {
  let self_obj = Object.assign({
    baseURL,
    headers: config.headers,
    timeout: config.timeout,
    ...config.other
  }, obj || {})
  return axios.create(self_obj);
}